export enum ManagerEnum {
    DCF = 'DCF'
}